import type { CeramicPackage } from '../data/protection-catalog.ts'

export function modIndex(index: number, length: number) {
  if (length <= 0) return 0
  return ((index % length) + length) % length
}

export function featuredPackageIndex(packages: CeramicPackage[]) {
  const index = packages.findIndex((item) => item.featured)
  return index >= 0 ? index : 0
}

export function carouselPlacement(
  index: number,
  activeIndex: number,
  packageCount: number,
): 'left' | 'featured' | 'right' | 'hidden' {
  if (index === activeIndex) return 'featured'
  if (index === modIndex(activeIndex - 1, packageCount)) return 'left'
  if (index === modIndex(activeIndex + 1, packageCount)) return 'right'
  return 'hidden'
}

export function browseCarousel(activeIndex: number, packageCount: number, direction: -1 | 1) {
  return modIndex(activeIndex + direction, packageCount)
}

export function protectionCarouselOptions() {
  return {
    align: 'center' as const,
    containScroll: false as const,
    dragFree: false,
    loop: true,
    skipSnaps: false,
    watchDrag: true,
    // Class/description updates must not reInit, or the track freezes on the
    // featured snap while selectedScrollSnap still advances.
    watchSlides: false,
  }
}
